module.exports = __webpack_public_path__ + "img/bubble.0a2dcb68.svg";